import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {WorkoutExerciseId} from '../../domain/workout-exercise-id.value-object';

export class WorkoutExerciseIdValidator implements Validator<WorkoutExerciseId> {
  readonly standardSchema = z.templateLiteral(['wke', '_', z.string().min(1)]);

  validate(value: unknown): Result<WorkoutExerciseId, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Invalid workout exercise id.',
        ),
      );
    }
    return ok(parsed.data);
  }
}
